import React, { useEffect, useMemo, useState } from 'react';

export default function TopTicker() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const label = useMemo(() => {
    return 'SPORTS';
  }, []);

  useEffect(() => {
    let isMounted = true;
    const fetchAllHeadlines = async () => {
      try {
        // Fetch headlines from all major sports
        const sports = ['college', 'nfl', 'nba', 'nhl', 'mlb'];
        const allHeadlines = [];
        
        // Fetch headlines from each sport
        const promises = sports.map(async (sport) => {
          try {
            const res = await fetch(`/api/espn-proxy?type=${sport}&headlines=true`);
            const data = await res.json();
            const headlines = (data.articles || data.headlines || [])
              .map((a) => a.headline || a.title)
              .filter(Boolean)
              .slice(0, 3); // Get 3 headlines per sport
            return headlines;
          } catch (e) {
            console.warn(`Failed to fetch ${sport} headlines:`, e);
            return [];
          }
        });
        
        const results = await Promise.all(promises);
        const combinedHeadlines = results.flat();
        
        // Shuffle the headlines to mix sports
        const shuffled = combinedHeadlines.sort(() => Math.random() - 0.5);
        
        if (isMounted) setItems(shuffled.slice(0, 15)); // Show up to 15 headlines
      } catch (e) {
        console.error('Error fetching headlines:', e);
        if (isMounted) setItems([]);
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    
    fetchAllHeadlines();
    const id = setInterval(fetchAllHeadlines, 1000 * 60 * 5); // Refresh every 5 minutes
    return () => { isMounted = false; clearInterval(id); };
  }, []); // Remove sportType dependency since we're fetching all sports

  if (loading || items.length === 0) return null;

  return (
    <div className="w-full bg-black text-white text-sm">
      <div className="max-w-6xl mx-auto py-2 flex items-center gap-3">
        <div className="flex-shrink-0 px-2 py-0.5 rounded bg-white/10 text-white/90 text-xs font-semibold">
          {label}
        </div>
        <div className="flex-1 overflow-hidden whitespace-nowrap">
          <div className="inline-flex animate-[ticker_60s_linear_infinite]">
            {items.concat(items).map((text, idx) => (
              <span key={idx} className="mx-6 opacity-90">{text}</span>
            ))}
          </div>
        </div>
      </div>
      <style>{`@keyframes ticker { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }`}</style>
    </div>
  );
}


